import AcademyAppConfig from './academy/AcademyAppConfig';
import ManagementConfig from './manage/ManagementConfig';
import WorkAppConfig from './works/WorkConfig';
import IndividualAppConfig from './individual/IndividualAppConfig';
import FileAppConfig from './files/FileConfig';

const appsConfigs = [AcademyAppConfig, ManagementConfig, WorkAppConfig, IndividualAppConfig, FileAppConfig];

export default appsConfigs;
